const MODALS = {
    COMPARISONS: {
        COMPONENT_DIFF: () => import('./modals/comparisons/component-diff/component-diff-modal.vue'),
        EDIT: () => import('./modals/comparisons/edit-comparison/edit-comparison-modal.vue'),
        DELETE: () => import('./modals/comparisons/delete-comparison/delete-comparison-modal.vue'),
        NEW: () => import('./modals/comparisons/new-comparison/new-comparison-modal.vue'),
        SHARE: () => import('./modals/comparisons/share-comparison/share-comparison-modal.vue'),
    },

    DEPLOYMENTS: {
        ADD_COMPONENTS: () => import('./modals/deployments/add-components/add-components-modal.vue'),
        NEW: () => import('./modals/deployments/new-deployment/new-deployment-modal.vue'),
    },

    GROUPS: {
        EDIT: () => import('./modals/groups/edit-group/edit-group-modal.vue'),
        DELETE: () => import('./modals/groups/delete-group/delete-group-modal.vue'),
        MANAGE_GROUP_MEMBERS: () => import('./modals/groups/manage-group-members/manage-group-members-modal.vue'),
        NEW: () => import('./modals/groups/new-group/new-group-modal.vue'),
    },

    ORGANIZATIONS: {
        EDIT: () => import('./modals/organizations/edit-organization/edit-organization-modal.vue'),
        DELETE: () => import('./modals/organizations/delete-organization/delete-organization-modal.vue'),
        NEW: () => import('./modals/organizations/new-organization/new-organization-modal.vue'),
        SHARE: () => import('./modals/organizations/share-organization/share-organization-modal.vue'),
    },
}

const PROMPTS = {}

export {
    MODALS,
    PROMPTS,
}
